import type { MenuTriggerProps } from '@chakra-ui/react';
import { Menu } from '@chakra-ui/react';
import { MsgPayloadType } from '@halo/chat-sdk';
import { CallVideoLineIcon, CallVoiceLineIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface ChatHeaderMediaCallProps {
  children: React.ReactNode;
  onMediaClick: (key: MsgPayloadType | string) => void;
  isGroup: boolean;
  triggerProps?: MenuTriggerProps;
}

function ChatHeaderMediaCall({
  children,
  onMediaClick,
  // isGroup,
  triggerProps,
}: ChatHeaderMediaCallProps) {
  const { t } = useTranslation();

  const items = useMemo(() => {
    const data = [
      {
        key: MsgPayloadType.MEDIA_AUDIO_CALL,
        label: (
          <>
            <CallVoiceLineIcon />
            <div>{t('calls.voiceCallTitle')}</div>
          </>
        ),
      },
      {
        key: MsgPayloadType.MEDIA_VIDEO_CALL,
        label: (
          <>
            <CallVideoLineIcon />
            <div>{t('calls.videoCallTitle')}</div>
          </>
        ),
      },
    ];
    // if (isGroup) {
    //   data.push({
    //     key: 'select-members' as any,
    //     label: <div>Select Members</div>,
    //   });
    // }
    return data;
  }, [t]);

  return (
    <Menu.Root positioning={{ placement: 'bottom-start' }}>
      <Menu.Trigger cursor="pointer" {...triggerProps}>
        {children}
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content
          boxShadow="0px 0px 18px 0px rgba(0, 0, 0, 0.1)"
          rounded="lg"
          minW="178px"
          p="1"
          backdropFilter="blur(6px)"
          bg="whiteAlpha.70"
        >
          {items.map((v: any) => {
            return (
              <Menu.Item
                display="flex"
                alignItems="center"
                gap="2.5"
                value={v.key}
                key={v.key}
                onClick={() => onMediaClick(v.key)}
                cursor="pointer"
                color="fg"
                fontSize="sm"
                fontWeight="semibold"
                px="2"
                py="3"
                _hover={{
                  bg: 'blackAlpha.3',
                  rounded: 'md',
                }}
              >
                {v.label}
              </Menu.Item>
            );
          })}
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}

const MemoizedChatHeaderMediaCall = memo(ChatHeaderMediaCall);

export { MemoizedChatHeaderMediaCall as ChatHeaderMediaCall };
